
import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

// Component styles
import styles from './styles';
import BaseDataRegisters from './BaseDataRegisters'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class BaseRegisters extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        var monitores=(props.location.state.fromObjective.Monitores)
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            errors:["","Solo puede seleccionar un día", "Ambas fechas no pueden ser iguales","Fecha inicial no puede ser mayor a Fecha Final", 
                    "Fecha Termino no puede superar fecha actual", "Rango debe ser de una Hora"],
            indexError:0,
            buttonBoolean:true,
            isLoad:false,
            dateMoment:moment(),
            dateBefore:moment().subtract({'hours': 1}),
            limit:new Date(new Date().setDate(new Date().getDate() - 6)),
            limit2:new Date(),
            clockBegin:new Date(new Date().setHours(new Date().getHours() - 1)),
            clockFinal:new Date(),
            open:false,
            isLoadButton:false,
        };
    }
    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.buttonBoolean!== this.state.buttonBoolean){
            this.getData()
        }
    }
    getData=()=>{
        this.setState({
            isLoad:false,
            isLoadButton:false,
        })
    }
    openModal=(event)=>{
        this.setState({
            open:true
        })
    }
    onChange=(date)=>{
        if((String(date[0])).substr(4,12)!==(String(date[1])).substr(4,12)){
            if(this.state.limit>date[0]){
                //console.log('si la fecha menor es menor al limite')
                this.setState({
                    indexError:1,
                    clockBegin:this.state.limit,
                    clockFinal:moment(this.state.limit).add({'hours':1})._d
                })
            }else{
                //console.log('la fecha limite es menor a la menor')
                this.setState({
                    indexError:1,
                    clockBegin:date[0],
                    clockFinal:moment(date[0]).add({'hours':1})._d
                })
            }
        }else{    
            if(moment(date[1]).unix()-moment(date[0]).unix()<=0){
                if(moment(date[1]).unix()-moment(date[0]).unix()<0){
                    //console.log('fecha menor mas grande ')
                    this.setState({
                        indexError:3,
                })
                }else{
                    //console.log('fecha igual')
                    this.setState({
                        indexError:2,
                    })
                }
            }else{
                if(this.state.limit2<date[1]){
                    //console.log('limite mayor menor a fecha final')
                    this.setState({
                        indexError:4,
                        clockBegin:moment(this.state.limit2).subtract({'hours':1})._d,
                        clockFinal:this.state.limit2
                    })
                        
                }else{
                    if(moment(date[1]).unix()-moment(date[0]).unix()>3600){
                        //console.log('rango mayor a una hora')
                        this.setState({
                            indexError:5,
                            clockBegin:date[0],
                            clockFinal:date[1],
                        })
                    }else{
                        //console.log('funciona')
                        this.setState({
                            indexError:0,
                            clockBegin:date[0],
                            clockFinal:date[1],
                        })
                    }
                } 
            }
        }
    }
    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleClose = event => {
        this.props.onClose()
    };
    
    changeLoad=()=>{
        //console.log('lo que llega desde boton changeLoad')
        const {clockBegin, clockFinal, indexError}=this.state
        if(indexError===0){
            this.setState({
                dateBefore:moment(clockBegin),
                dateMoment:moment(clockFinal),
                isLoadButton:true,
                open: false
            })
        }
        
    }
    render() {
        
        const { classes } = this.props;
        const {nodes, steps, objetive, dateMoment, dateBefore, errors,
                indexError, isLoad, limit, limit2, open, clockBegin, 
                clockFinal, isLoadButton, callbackFromElements} = this.state;
        
        if (isLoad===true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return (
                <Portlet className={classes.backGrey}>
                    <PortletHeader style={{height:"200px"}}>
                        <PortletToolbar style={{width:"100%"}}>
                            <Grid
                                container direction="row" justify="center" alignItems="flex-end" spacing={1}
                            >
                                <Grid
                                    item
                                    xs={10}
                                    md={10}
                                    xl={10}
                                    //style={{paddingBottom:"5px"}}
                                >
                                    <Typography variant="h3" className={classes.textWhite}>Registros Plus</Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={2}
                                    md={2}
                                    xl={2}
                                    //style={{paddingBottom:"5px"}}
                                >
                                    <IconButton key="close" aria-label="close" style={{color:"white", float:'right'}} onClick={this.handleClose}><CloseIcon/></IconButton>
                                </Grid>
                                
                                    
                                <Grid
                                //style={{textAlign:"right", paddingTop:"16px"}}
                                item
                                xs={12}
                                md={12}
                                xl={12}
                                >
                                    <Button style={{backgroundColor:"#FF4500"}} onClick={this.openModal.bind(this)}>
                                        <Typography variant="button" className={classes.textWhite} >Filtrar</Typography>
                                    </Button>
                                </Grid>
                                
                                <Modal
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    open={open}
                                    onClose={this.onCloseModal}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: "30vw",
                                        left:"305px",
                                        top:"-155px"
                                    }}
                                    disableAutoFocus={true}
                                    disableEnforceFocus={true}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Grid
                                        container direction="row" justify="center" alignItems="flex-end" spacing={1}
                                        style={{backgroundColor:"white"}}
                                    >
                                        <Grid
                                            item
                                            xs={10}
                                            md={10}
                                            xl={10}
                                            style={{textAlign:"center"}}
                                        >
                                            <Typography variant="h5" style={{color:"#7a7e7e"}} >Seleccione Rango dentro de una hora de un día</Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            md={2}
                                            xl={2}
                                            //style={{paddingBottom:"5px"}}
                                        >
                                            <IconButton key="close" aria-label="close" onClick={this.onCloseModal}><CloseIcon/></IconButton>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center"}}
                                        >
                                            <DateTimeRangePicker 
                                                clearIcon={null}
                                                style={{}}
                                                onChange={this.onChange}
                                                value={[clockBegin, clockFinal]}
                                                format={"y-MM-dd HH:mm:ss"}
                                                minDate={limit}
                                                maxDate={limit2}
                                                rangeDivider=" Hasta "
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center"}}
                                        >
                                            <Typography style={{color:"red"}}>
                                                {errors[indexError]}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center"}}
                                        >
                                            {isLoadButton?
                                            <Typography
                                            variant="caption"
                                            >
                                                <CircularProgress
                                                variant="indeterminate"
                        
                                                size={8}
                                                thickness={2}
                                                
                                            />
                                                Cargando Información...
                                            </Typography>
                                            :
                                            <Button style={{backgroundColor:"#FF4500"}} onClick={this.changeLoad.bind(this)}>
                                                <Typography variant="button" className={classes.textWhite} >Generar</Typography>
                                            </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                </Modal>
                            </Grid>
                        </PortletToolbar>
                    </PortletHeader>
                    <PerfectScrollbar>
                        <BaseDataRegisters callbackFromParent={this.myCallback} nodes={nodes} objective={objetive} steps={steps} dateBegin={dateBefore} dateFinal={dateMoment}/>
                    </PerfectScrollbar>
                </Portlet>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles))(BaseRegisters);